/*
 * PROD-7828 W3 — Invoices: query params, pinned to teacher_invoice_ops_enums (request_fields_read/required)
 * by request_fields.test.js. Months are 'YYYY-MM'.
 */
export const INVOICE_PAGE_SIZE = 100;

// The overview's own cap (overview_plan.go maxOverviewLimit): one read covers a month's teachers.
export const AWAITING_PAGE_SIZE = 500;

export const STATUS_CONFIRMED = 'CONFIRMED';
export const STATUS_SUPERSEDED = 'SUPERSEDED';
export const STATUS_ALL = 'ALL';

// after_id: the previous page's next_after_id (0 = first page).
export const list_params = (pay_month, status, after_id, limit = INVOICE_PAGE_SIZE) => ({
  pay_month,
  status: status || STATUS_CONFIRMED,
  after_id: after_id || 0,
  limit
});

export const pdf_params = (invoice_uuid) => ({ invoice_uuid });

/*
 * "Awaiting invoice" reads the overview's teacher rows (its invoice_status is the month row's, set on
 * confirm and reset on reopen); only closed months can have an invoice, so the server filters to CLOSED.
 */
export const awaiting_l1_params = (pay_month, offset = 0) => ({
  pay_month,
  lifecycle: 'CLOSED',
  sort: 'teacher_name',
  dir: 'asc',
  limit: AWAITING_PAGE_SIZE,
  offset
});
